import { EXOTEL_APIS, PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export interface ICreateCreditNoteProps {
  user_id: string;
  invoice_id: string;
  mode: string;
  credit_amount: number;
  return_reason: string;
  comments: string;
  clinic_id: string;
  clinic_name: string;
}
export const useUseCallDispositationAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async (paramsBody: ICreateCreditNoteProps) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(`${EXOTEL_APIS?.EXOTEL_CALL_DISPOSITION?.baseURL}`, paramsBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            const hasStatusFlag = typeof res?.data?.status === "boolean";
            const hasSuccessFlag = typeof res?.data?.success === "boolean";
            const hasExplicitFailure = res?.data?.status === false || res?.data?.success === false;
            const hasExplicitSuccess = res?.data?.status === true || res?.data?.success === true;
            const isHttpSuccess = typeof res?.status === "number" && res.status >= 200 && res.status < 300;
            const isSuccess = hasExplicitFailure
              ? false
              : hasExplicitSuccess
                ? true
                : hasStatusFlag || hasSuccessFlag
                  ? false
                  : isHttpSuccess;

            if (isSuccess) {
              return { status: true, message: res?.data?.message ?? "Call disposition updated" };
            }

            return { status: false, message: res?.data?.message ?? "Call disposition failed" };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
